<template>
	<div class="column rigid">
		<label v-for="(plan, index) in planList" :key="index" class="list-item empty">
			<div class="row centering separated gap">
				<div class="column gap separated">
					<span class="label row separated rigid">
						<div class="placeholder">
							<span class="invisible">Placeholder</span>
						</div>
					</span>
					<span class="row rigid" v-show="desc">
						<div class="display-text rigid">
							<div class="placeholder">
								<span class="invisible">Placeholder</span>
							</div>
						</div>
					</span>
				</div>
				<footer class="row rigid">
					<div class="plan-subscription">
						<div class="plan-rate">
							<span class="plan-price"></span>
						</div>
					</div>
				</footer>
			</div>
		</label>
	</div>
</template>

<script>
export default {
	name: 'PlanPlaceholder',
	data(){
		return {
			planList: []
		};
	},
	props: {
		desc: Boolean,
		rows: Number
	},
	created() {
		const rows = this.rows || 1;
		for (let i = 0; i < rows; i++) {
			this.planList.push(i);
		}
	}
};

</script>

<style scoped>
	.plan-option.empty {
		width: 100%;
	}
	.label .placeholder {
		width: 250px;
	    background: #ddd;
	}
	.display-text .placeholder{
		width: 200px;
		background: #f6f6f6;
	}
</style>



// WEBPACK FOOTER //
// ./src/components/SettingPlaceholder.vue